/**
 * Centralized API and URL configuration
 * 
 * IMPORTANT: Never hardcode URLs in components!
 * Always import from this file to ensure URLs work in both preview and production.
 * 
 * Usage:
 *   import { API_URL, BACKEND_URL, getAssetUrl } from '@/config/api';
 *   
 *   // For API calls:
 *   fetch(`${API_URL}/albums`)
 *   
 *   // For assets served by backend:
 *   <img loading="lazy" decoding="async" src={getAssetUrl('/music_library/covers/image.png')} />
 */

// Base backend URL from environment
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// API endpoint (backend URL + /api prefix)
export const API_URL = `${BACKEND_URL}/api`;

/**
 * Get full URL for an asset served by the backend
 * @param {string} path - Path starting with / (e.g., '/music_library/covers/image.png')
 * @returns {string} Full URL to the asset
 */
export const getAssetUrl = (path) => {
  // Ensure path starts with /
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${BACKEND_URL}${cleanPath}`;
};

/**
 * Get full URL for an API asset (served under /api/)
 * @param {string} path - Path without /api prefix (e.g., 'music_library/covers/image.png')
 * @returns {string} Full URL to the API asset
 */
export const getApiAssetUrl = (path) => {
  // Remove leading slash if present, we'll add /api/
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_URL}/${cleanPath}`;
};

/**
 * Check if we're in production environment
 * @returns {boolean}
 */
export const isProduction = () => {
  return BACKEND_URL.includes('casasamba.com') || 
         BACKEND_URL.includes('onestopcontentshop');
};

/**
 * Check if we're in preview/development environment
 * @returns {boolean}
 */
export const isPreview = () => {
  return BACKEND_URL.includes('preview.emergentagent.com');
};

// Default export for convenience
export default {
  BACKEND_URL,
  API_URL,
  getAssetUrl,
  getApiAssetUrl,
  isProduction,
  isPreview
};
